const isLoading = {
  data: function() {
    return {
      isLoading: false,
    }
  },
}

module.exports = isLoading
